import React from 'react';
import { Outlet } from 'react-router-dom';
import { MeiucaAppLayout } from '../../components/MeiucaAppLayout';

export default function AppLayoutPage() {
  return (
    <MeiucaAppLayout>
      <Outlet />
    </MeiucaAppLayout>
  );
}